/** APP DEEPLINK */
export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=jp.co.zigexn.relifepass';
export const IOS_APP_URL = 'https://apps.apple.com/jp/app/%E7%8B%AC%E7%AB%8B-%E8%B5%B7%E6%A5%AD%E3%81%AE%E3%81%9F%E3%82%81%E3%81%AE%E3%82%B9%E3%82%AB%E3%82%A6%E3%83%88%E3%82%A2%E3%83%97%E3%83%AA%E3%83%AA%E3%83%A9%E3%83%91%E3%82%B9/id6448170478';
export const DEEPLINK_BASE_URL = `${import.meta.env.VITE_APP_URL}/app`;

export const APP_BUNDLE_ID = 'jp.co.zigexn.relifepass';
export const APP_SCHEME = 'relifepass-scheme';
export const IOS_REDIRECT_URI = `${APP_SCHEME}://`;

export const ANDROID_REDIRECT_URI = `intent:#Intent;scheme=${APP_SCHEME};package=${APP_BUNDLE_ID};action=VIEW;end`;
